webpackJsonp([22],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[85]);


// WEBPACK FOOTER //
// bundles/contact.bundle.js